import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import { withTranslation } from 'react-i18next';

class AccountControls extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    onResetPassword: PropTypes.func.isRequired,
  }

  onResetPassword = () => {
    if (window.confirm(i18n.t('confirm.resetPassword'))) {
      const { account, onResetPassword } = this.props;
      onResetPassword(account.id, account.email);
    }
  }

  render() {
    return (
      <div className='row'>
        <div className='column small-12 u-margin-bottom--small'>
          <a className='o-sp-button o-sp-button--primary o-sp-button--expanded' onClick={this.onResetPassword}>{this.props.t('account.resetPassword')}</a>
        </div>
      </div>
    )
  }
}

export default withTranslation()(AccountControls);
